import { H4, UL } from "../../../AbstractElements";
import { CommentBlog2, Comments, SingleBlogParagraph, SingleBlogParagraphs } from "../../../Constant";
import UserComment from "./common/UserComment";

const CommentSection = () => {
  return (
    <section className="comment-box">
      <H4>{Comments}</H4>
      <hr />
      <UL className="simple-list">
        <UserComment ImageSrc="comment.jpg" userReplay text={SingleBlogParagraph} />
        <UserComment ImageSrc="4.jpg" text={CommentBlog2} />
        <UserComment ImageSrc="12.png" text={SingleBlogParagraphs} />
        <UserComment ImageSrc="14.png" text={SingleBlogParagraphs} />
      </UL>
    </section>
  );
};

export default CommentSection;
